module.exports = __webpack_public_path__ + "static/media/cosmetics_banner.8dbcfe2a.jpg";